"use client";

// MenuFooter — the FULL footer, exactly the landing page's closing bar
// (`.fcta-bar`): the still brand lockup, the one quiet row of public links, the
// Product Hunt badge, and the social marks. It rides the bottom of the menu
// takeover on every surface, so wherever you open the ≡ you get the same way out
// to every public page. One source: `FOOTER_LINKS` in lib/nav/siteNav.

import OrganismSpinner from "./brand/OrganismSpinner";
import Wordmark from "./brand/Wordmark";
import SocialLinks from "./SocialLinks";
import ProductHuntBadge from "./ProductHuntBadge";
import { FOOTER_LINKS } from "../lib/nav/siteNav";

export default function MenuFooter({ open }: { open: boolean }) {
  return (
    <div className="menu-foot" data-open={open ? "true" : undefined} aria-hidden={!open}>
      <div className="fcta-bar" style={{ borderTop: "none", paddingTop: 0 }}>
        <a href="/" className="fcta-bar__mark" aria-label="innernet home">
          <OrganismSpinner size={22} tone="current" spin={false} />
          <Wordmark tone="current" height="1.15rem" title="innernet" />
        </a>
        <nav className="fcta-bar__links" aria-label="footer">
          {FOOTER_LINKS.map(([label, href]) => (
            <a key={label} href={href} tabIndex={open ? 0 : -1}>{label}</a>
          ))}
        </nav>
        <div className="fcta-bar__badges">
          <span className="fcta-bar__ph"><ProductHuntBadge theme="light" width={190} /></span>
          <span className="fcta-bar__social"><SocialLinks /></span>
        </div>
      </div>
    </div>
  );
}
